import { mapGetters, mapMutations } from 'vuex';
import applCode from '@/const/applCodeConstants';
import routerNames from '@/const/routerConstants';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('ELA', [
      'GET_APP_MAP_DATA',
      'GET_MAP_REASON',
      'GET_APPL_MAP_PARAM',
    ]),
    ...mapGetters('SPINNER', ['GET_APP_LOADING_STATUS']),
    ...mapGetters('ELA', ['GET_APP_MENU']),
    // 연장근무
    isOtWork() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.OtWork;
    },
    // 출퇴근 변경
    isAttend() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.Attend;
    },
    // 근무스케쥴 변경
    isSchedule() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.Schedule;
    },
    // 보상휴가
    isReward() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.Reward;
    },
    // 근태
    isVacation() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.Vacation;
    },
    // 취소신청 - 근태
    /*
    isCancelVacation() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.CancelVacation;
    },
    */
    // 근태/휴가 취소신청
    isVacationCancel() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.VacationsCancel;
    },
    // 취소신청 - 보상
    isCancelReward() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.CancelReward;
    },
    // 독감예방접종
    isVaccation() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.Vaccination;
    },
    // 학자금
    isEdusApp() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.EdusApp;
    },
    // 육아휴직
    isLeaAbsParental() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.LeaAbsParental;
    },
    // 가족돌봄휴직
    isLeaAbsFamily() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.LeaAbsFamily;
    },
    // 난임치료휴직
    isLeaAbsInfertility() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.LeaAbsInfertility
      );
    },
    // 휴직연장
    isLeaEaAbsExtension() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.eaAbsExtension;
    },
    // 복직신청
    isLeaAbsApplication() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.LeaAbsApplication
      );
    },
    // 공상휴직
    isLeaAbsSick() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.LeaAbsSick;
    },
    // 사상휴직
    isLeaAbsCasualty() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.LeaAbsCasualty;
    },
    // 신상휴직
    isLeaAbsNew() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.LeaAbsNew;
    },
    // 휴직연장
    isLeaAbsExtension() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.LeaAbsExtension;
    },
    // 휴직추가
    isLeaAbsAdd() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.LeaAbsAdd;
    },
    // 휴일근무사전대체신청
    isHolReplace() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.HolReplaceApp;
    },
    // 휴일근무사전대체취소신청
    isHolReplaceCancel() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.HolReplaceBoxView
      );
    },
    // 재직증명서(한글)
    isReCertTenure() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.ReCertTenureAppView
      );
    },
    // 재직증명서(영문)
    isReCertTenureEng() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.ReCertTenureEngAppView
      );
    },
    // 원천징수영수증
    isReCertTax1() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd ===
        applCode.ReCertTenureTax1AppView
      );
    },
    // 원청징수부
    isReCertTax2() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd ===
        applCode.ReCertTenureTax2AppView
      );
    },
    // 휴직증명서
    isReCertLeave() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.ReCertLeaveAppView
      );
    },
    // 갑근세증명원
    isReCertGabTax() {
      return this.GET_APPL_MAP_PARAM.searchApplCd === applCode.ReCertGabTaxView;
    },
    // 시차출퇴근
    isWorkScheduleTime() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.WorkScheduleTime1
      );
    },
    // 시차출퇴근
    isVaction() {
      return (
        this.GET_APPL_MAP_PARAM.searchApplCd === applCode.Vacations
      );
    },
    /* 호출 view */
    // 신청 완료
    isApplConfirmViewer() {
      return (
        this.appInfoParam.viewerType !== undefined &&
        this.appInfoParam.viewerType === 'applConfirm'
      );
    },
    // 결재함
    isApprDocViewer() {
      return this.$route.name === routerNames.ApprDoc;
    },
    // 내문서함
    isMyBoxViewer() {
      return this.$route.name === routerNames.MyBox;
    },
    // 취소메뉴
    isCancelMenu() {
      return this.$route.name === routerNames.CancelMenu;
    },

    confirmTitle() {
      // 신청 완료화면 제목
      if (this.isApplConfirmViewer) {
        let msg = `신청이<br v-show="GET_GNT_CD_NM.length > 7" />완료 되었습니다.`;
        if (this.isSchedule) {
          return `근무스케줄 변경 ${msg}`;
        } else if (this.isAttend) {
          return `출퇴근시간 변경 ${msg}`;
        } else if (this.isOtWork) {
          return `연장근무 ${msg}`;
        } else {
          return `${this.GET_GNT_CD_NM}
          ${this.isCancelMenu ? ' 취소' : ' '} ${msg}`;
        }
      }
    },
    cancelApplBtn() {
      return this.cancelBtnShow;
    },
  },
  methods: {
    ...mapMutations('CODE', ['SET_GNT_CODE_TMP', 'SET_GNT_GUBUN_TMP']),
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),
  },
  destroyed() {
    this.$store.commit('ELA/SET_APP_MAP_DATA', {});
  },
};
